//Must be URL-safe. This is what will show up in the URL, e.g. the "case" in "case/42"
export enum MenuItemTypes {
	Case = "case",
	Participant = "participant",
	Phase = "phase",
    Eligibility = 'eligibility'
}
